import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import axios from "axios/index";
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';

import urls from "../../../../utils/urls";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import helpers from '../../../../utils/helpers';
import ToggleInput from '../../../../components/ToggleInput/toggleInput';
import { reloadTrip } from '../../../../actions/trip_actions';
import TripRejectModal from './TripRejectModal';

import TripWaitingScale from "./TripWaitingScale";

class TripDocControl extends Component {

    constructor(props) {
        super(props);

        this.state = {
            canEdit: helpers.canUserDischarge(props.user),
            ajaxInProgress: false,
            trip: this.props.trip,
            rejection_reasons: false,
            documentation: null,
            tanks: '',
            rejection_reason: '',
            rejection_observations: ''
        }
    }

    componentDidMount() {
        this._fetchOptions();
    }

    _initializeHtml = () => {
        window.initializeCollapsible();
        window.initializeSelects('body');
        window.bindSelectAction(this.reasonSelect, this._handleSelectChange);
    }

    _fetchOptions = () => {
        const REASONS_URL = `${urls.API_ROOT}/api/v1/rejectionreasons/`;
        axios.get(REASONS_URL, tokenHeader())
            .then((response) => {
                this.setState({
                    rejection_reasons: response.data
                }, this._initializeHtml);
            })
            .catch((error) => ajaxHandler(error));
    }

    _handleInput = (prop, value) => {

        // Custom validations

        this.setState({[prop]: value});
    };

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value});
    }

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _submitForm = () => {

        if(!this.state.tanks || isNaN(this.state.tanks) || this.state.tanks === 0){
            swal({
                title: 'Campos incompletos',
                html: 'Por favor, ingrese la cantidad de tanques',
                type: 'error'
            });
            return false;
        }

        let data = {
            trip: this.props.trip.id,
            quality_letter_check: this.state.documentation,
            compartments: this.state.tanks
        };

        const DOCUMENTATION_URL = `${urls.API_ROOT}/api/v1/documentation_control/`;
        axios.post(`${DOCUMENTATION_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Viaje actualizado',
            html: 'El control ha sido ingresado correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    }

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido crear el despacho',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    _goBack = () => {

        let {tanks, compartments} = this.state;
        let warning = (compartments !== '' || tanks);

        if(warning){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/')
        }

    };

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        if(!this.state.canEdit){
            return <TripWaitingScale message={"Esperando control de documentación"} />;
        }


        // If there's an ajax call in progress or if user can not edit
        let disableButtons = this.state.ajaxInProgress || this.state.documentation === false;
        let message = `Un viaje no puede ser ingresado si el control de la carta de calidad es insatisfactorio. ` +
            `Este viaje tiene que ser rechazado, por favor complete el formulario que se encuentra debajo para continuar.`;

        return (
            <div>
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Control de documentación</div>
                    <div className={"row no-padding thin-row trip-form padding-top-10"} style={{minHeight: '160px'}}>
                        <div className={"col s4"}>
                            <ToggleInput
                                selected={this.state.documentation}
                                name={'¿Trae carta calidad proveedor?'} stateVar={'documentation'}
                                toggleAction={this._handleToggle}
                            />
                            {this.state.documentation &&
                            <div className="input-subtitle green-text">Documentación aprobada</div>
                            }
                            {this.state.documentation === false &&
                            <div className="input-subtitle red-text">Documentación rechazada</div>
                            }
                        </div>
                        <div className={"col s6 m4 input-field input-grey"}>
                            <label className="active">Cantidad de cisternas</label>
                            <input placeholder={"Ingrese la cantidad de tanques"} value={this.state.tanks}
                                   onChange={(ev) => this._handleInput('tanks', ev.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._goBack}
                              className={`btn btn-shell-empty z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Volver
                        </button>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Guardar
                        </button>
                    </div>
                </div>
                {this.state.documentation === false && this.props.reloadTrip &&
                    <TripRejectModal trip={trip} showButton={false}
                                     reloadTrip={this.props.reloadTrip}
                                     message={message}
                                     afterCloseAction={() => this.setState({documentation: null})}
                                     source={"doc_control"} />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({reloadTrip}, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TripDocControl));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripDocControl.js